
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CAktPassedTestingsEmptyResult"
})
export default class CAktPassedTestingsEmptyResult extends Vue {}
